<template>
  <div class="post">
    <div v-if="fullPost.autoplayVideo" class="featured-media">
      <iframe v-if="autoplayVideo" width="800" height="450" :src="autoplayVideo" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      <button v-if="fullPost.media.length >= 1" class="btn btn-primary gallery-button" @click="index = 0"><i class="far fa-images"></i> View Gallery</button>
    </div><!-- /.featured-media -->
    <div v-if="fullPost.media.length >= 1 && fullPost.autoplayVideo == null" class="featured-media">
      <img :src="fullPost.media[0].large" alt="Featured Image" @click="index = 0"/>
      <button class="btn btn-primary gallery-button" @click="index = 0"><i class="far fa-images"></i> View Gallery</button>
    </div><!-- /.featured-media -->
    <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
    <div class="post-header">

      <h1>{{ fullPost.title }}</h1>

      <p class="lead">Posted by <router-link :to="{ name: 'UserProfile', params: {id: fullPost.userId}}" >{{ fullPost.userName }}</router-link></p>

      <!-- Post Options -->
      <div class="post-options mb-4 clickable" @click="listSelect = true">
        <i class="fas fa-plus-circle"></i>
      </div>

      <!-- Figures -->
      <div class="figures">
        <div class="card-columns">
          <div v-for="figure in fullPost.figures" v-if="figure.value > 0" class="card p-3">
            <div class="card-body">
              <p>{{ figure.title }}</p>
              <h2>${{ formatFigure(figure.value) }}</h2>
            </div><!-- /.card-body -->
          </div><!-- /.card -->
        </div><!-- /.card-columns -->
      </div><!-- /.figures -->

      <!-- Render the dates if they exist -->
      <div class="dates" v-if="fullPost.dates.start">
        <span v-if="fullPost.dates.yearsOnly == true"><i class="far fa-calendar-alt"></i> {{ fullPost.dates.start | formatYear }} - {{ fullPost.dates.end | formatYear }}</span>
        <span v-if="fullPost.dates.yearsOnly == false"><i class="far fa-calendar-alt"></i> {{ fullPost.dates.start | formatFullDate }} - {{ fullPost.dates.end | formatFullDate }}</span>
      </div><!-- dates -->

    </div><!-- /.post-header -->

    <div class="post-body" v-if="renderLinks">
      <div class="row">
        <div class="col-md-9" v-html="fullPost.body">
        </div>
        <div class="col-md-3">
          <a v-for="link in fullPost.links" :href="link.url" target="_blank">
            <div class="post-link">
              <i class="far fa-link"></i> {{ link.title }}
            </div><!-- /.post-link -->
          </a>
        </div><!-- /.col-md-3 -->
      </div><!-- /.row -->
    </div><!-- /.post-body -->
    <div v-else class="post-body" v-html="fullPost.body">
    </div><!-- /.post-body -->

    <div class="post-footer">
      <div id="map" style="width:100%;height:300px;"></div>
    </div><!-- /.post-footer -->

    <ListsSelectModal v-if="listSelect" v-on:closeListsSelectModal="listSelect = false" :fullPost="fullPost"></ListsSelectModal>

  </div><!-- /.post -->
</template>

<script>
  import moment from 'moment'
  import VueGallerySlideshow from 'vue-gallery-slideshow'
  import fitvids from 'fitvids'
  import ListsSelectModal from './ListsSelectModal.vue'

  export default {
    props: ['fullPost'],
    components: { VueGallerySlideshow, moment, ListsSelectModal },
    data() {
      return {
        images: [],
        index: null,
        autoplayVideo: null,
        renderLinks: false,
        listSelect: false
      }
    },
    mounted() {
      fitvids()
    },
    created() {
      let self= this;
      // Check to see if there are Links
      if (self.fullPost.links && self.fullPost.links[0].title != '') {
        self.renderLinks = true
      }
      // Check for autoplayVideo and setup the player if so
      if (self.fullPost.autoplayVideo) {
        // Function for getting video id from a youtube link
        let videoId = youtube_parser(self.fullPost.autoplayVideo)
        function youtube_parser(url){
          var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          var match = url.match(regExp);
          return (match&&match[7].length==11)? match[7] : false;
        }

        console.log(videoId)
        self.autoplayVideo = 'https://www.youtube.com/embed/' + videoId + '?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1'
      }
      // Create an array of images for the gallery then push that array to this.images
      let imageArray = []
      let i;
      for (i = 0; i < self.fullPost.media.length; i++) {
        imageArray.push(self.fullPost.media[i].medium)
      }
      self.images = imageArray;

      // Create the map
      let map = null;
      setTimeout(function () {
        map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: self.fullPost.coordinates.latitude,lng: self.fullPost.coordinates.longitude},
          zoom: 18,
          scrollwheel: false
        });
        let marker = new google.maps.Marker({
          map: map,
          position: {lat: self.fullPost.coordinates.latitude,lng: self.fullPost.coordinates.longitude}
        });
        let address = self.fullPost.address
        let infowindow = new google.maps.InfoWindow({
          content: address.route + "<br>" + address.locality + " " + address.administrative_area_level_1 + ", " + address.postal_code
        });
        if (address.route) {
          infowindow.open(map, marker);
          marker.addListener('click', function() {
            infowindow.open(map, marker);
          });
        }
      }, 1000);
    },
    methods: {
      formatFigure(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      closePostModal() {
        this.$emit('closePostModal', false)
      },
      openEditPostModal(fullPost) {
        this.$emit('openEditPostModal', fullPost)
        this.$emit('closePostModal', false)
      }
    },
    filters: {
      formatFullDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        let year = moment(date).year()
        let month = moment(date).month() + 1
        let day = moment(date).date()
        let completeDate = month + '/' + day + '/' + year
        return completeDate
      },
      formatYear(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).year()
      },
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) { return val }
        return `${val.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Post.vue